export type AppShadowsKey =
  | 'textFieldFocused'
  | 'primaryButtonActive'
  | 'card'
  | 'flyoutFooter'
  | 'alert'

/**
 * Vacasa shadows used by various UIs components
 */
const textFieldFocused = '1px 1px 10px rgba(112, 117, 121, 0.2)'
const primaryButtonActive = '1px 1px 10px rgba(0, 51, 73, 0.45)'
const card = '0px 0px 20px rgba(0, 0, 0, 0.1)' //#707579
const flyoutFooter = '0px 0px 20px rgba(0, 0, 0, 0.15)'
const alert = '1px 1px 10px rgba(112, 117, 121, 0.2)'

const boxShadows: Record<AppShadowsKey, string> = {
  textFieldFocused,
  primaryButtonActive,
  card,
  flyoutFooter,
  alert,
}

export default boxShadows
